module.exports = {"230833100":"抚远镇","230833101":"寒葱沟镇","230833102":"浓桥镇","230833103":"乌苏镇","230833200":"通江乡","230833201":"浓江乡","230833202":"海青乡","230833203":"别拉洪乡","230833204":"鸭南乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230833.json
// module id = 707
// module chunks = 0